module.exports = __webpack_public_path__ + "static/media/Eye.02e4f673.svg";